module.exports = __webpack_public_path__ + "assets/img/pr.e52dcd9c.png";